import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import AuthCallback from 'pages/AuthCallback';
import Element from 'pages/Element';
import Env from 'pages/Env';
import ForgotPassword from 'pages/ForgotPassword';
import Home from 'pages/Home';
import Landing from 'pages/Landing';
import Login from 'pages/Login';
import Page from 'pages/Page';
import ResetPassword from 'pages/ResetPassword';
import Signup from 'pages/Signup';
import SignupSuccess from 'pages/SignupSuccess';
import Support from 'pages/Support';
import Thread from 'pages/Thread';

export const router = createBrowserRouter(
  [
    {
      element: <Page />,
      children: [
        {
          path: '/',
          element: <Home />
        },
        {
          path: '/thread/:id?',
          element: <Thread />
        },
        {
          path: '/share/:id',
          element: <Thread />
        }
      ]
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/element/:id',
      element: <Element />
    },
    {
      path: '/welcome',
      element: <Landing />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '/signup',
      element: <Signup />
    },
    {
      path: '/signup/success',
      element: <SignupSuccess />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/reset-password',
      element: <ResetPassword />
    },
    {
      path: '/support',
      element: <Support />
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
